import React from 'react';

import {Button, Notification} from '@ergeon/core-components';

type SessionExpiredNoticeProps = {
  onAuth(): void;
  onDismiss(): void;
};

function SessionExpiredNotice({onAuth, onDismiss}: SessionExpiredNoticeProps) {
  return (
    <div className="fixed bottom-4 left-4 z-[1000] w-80" role="alert">
      <Notification data-testid="session-expired-notice" mode="floating" onClose={onDismiss} type="Information">
        <h6 className="text-gray-900 dark:text-white heading-6">Session expired</h6>
        <p className="text-gray-700 dark:text-gray-300 paragraph-2 break-words max-w-full">
          Sign in again to keep working.
        </p>
        <div>
          <Button onClick={onAuth} size="small">
            Sign in
          </Button>
        </div>
      </Notification>
    </div>
  );
}

export default SessionExpiredNotice;
